import moment from 'moment';
import Configuration from 'common/src/app/config/Configuration';

moment.updateLocale('en', {
  meridiem(hour) {
    return hour < 12 ? Configuration.amFormat : Configuration.pmFormat;
  },
});
